import { LoaderCircleIcon as LucideLoaderCircleIcon } from "lucide-react";
import type { DsIcon } from "./types";
import { iconVariants } from "./variants-icon";

export const LoaderIcon: DsIcon = (props) => {
  return <LucideLoaderCircleIcon className={iconVariants(props)} />;
};
